import React from "react";
import { useLang } from "../i18n/LanguageContext";
import { Reveal, SectionHeading } from "./Reveal";

export const Features = () => {
  const { t } = useLang();

  return (
    <section id="features" className="relative py-24 md:py-32 bg-[#0D0D0D] border-y border-[#1c1c1c]" data-testid="features-section">
      <div className="px-6 md:px-12 lg:px-20">
        <SectionHeading overline={t.features.overline} title={t.features.title} center />

        {/* General stats */}
        <div className="mt-16 grid grid-cols-2 lg:grid-cols-5 gap-px bg-[#2E2E2E] border border-[#2E2E2E]">
          {t.features.general.map((stat, i) => (
            <Reveal key={i} delay={0.06 * i}>
              <div className="bg-[#0A0A0A] px-6 py-10 text-center h-full flex flex-col justify-center" data-testid={`stat-card-${i}`}>
                <p className="font-serif text-4xl lg:text-5xl font-light text-[#D4AF37] leading-none">
                  {stat.value}
                  {stat.unit && <span className="text-xl text-[#FFFFF0]/50 ms-1">{stat.unit}</span>}
                </p>
                <p className="mt-4 text-xs uppercase tracking-[0.16em] text-[#FFFFF0]/55">{stat.label}</p>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Block C details */}
        <Reveal delay={0.1}>
          <div className="mt-16 flex items-center gap-4">
            <span className="overline">{t.features.blockTitle}</span>
            <span className="flex-1 h-px bg-[#2E2E2E]" />
          </div>
        </Reveal>

        <div className="mt-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {t.features.block.map((item, i) => (
            <Reveal key={i} delay={0.04 * i}>
              <div className="bg-[#141414] border border-[#2E2E2E] p-5 hover:border-[#D4AF37]/40 transition-colors duration-500 h-full" data-testid={`block-card-${i}`}>
                <p className="text-[0.7rem] uppercase tracking-[0.14em] text-[#FFFFF0]/50">{item.label}</p>
                <p className="mt-2 font-serif text-2xl font-light text-[#FFFFF0]">{item.value}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
